export default __webpack_public_path__ + "static/media/Manuel.29d981f6.png";